/** Small reusable component for the common vertical bolded header + text pattern in the designs */

import { Texto, Vertical } from '@gravitate-js/excalibrr'
import type { TextoProps } from '@gravitate-js/excalibrr/dist/components/DataDisplay/Texto/Texto'
import type { CSSProperties } from 'react'

export function TitleLabel({
  title,
  children,
  align = 'left',
  flex = 'initial',
  strikethrough,
  headerStyle,
  labelStyle,
}: {
  title: string
  children: React.ReactNode
  align?: CSSProperties['textAlign']
  flex?: CSSProperties['flex']
  strikethrough?: boolean
  headerStyle?: TextoProps['style']
  labelStyle?: TextoProps['style']
}) {
  return (
    <Vertical justifyContent='space-between' flex={flex}>
      <Texto weight='bold' category='label' style={{ lineHeight: 1, textAlign: align, ...headerStyle }}>
        {title}
      </Texto>
      <Texto
        appearance={!children ? 'hint' : 'default'}
        className='text-ellipsis'
        style={{
          textAlign: align,
          textDecoration: strikethrough ? 'line-through' : '',
          ...labelStyle,
        }}
      >
        {children || 'N/A'}
      </Texto>
    </Vertical>
  )
}
